import TransporterApi from '@/api/transporter/transporter-api'

export default {
  namespaced: true,
  state: {

  },
  mutations: {

  },
  actions: {
    async addOrUpdate({dispatch}, form) {
      try {
        await TransporterApi.addOrUpdate(form);
        dispatch('NOTIFY_MSG', 'transporter.notification.save',
          { root: true});
        return Promise.resolve();
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async delete({dispatch}, {id}) {
      try {
        await TransporterApi.delete(id);
        dispatch('NOTIFY_MSG', 'transporter.notification.delete',
          { root: true});
        return Promise.resolve();
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async fetch({dispatch}) {
      try {
        const response = await TransporterApi.fetch();
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    }  }
}
